import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { type RadioProps, Radio } from '../Radio';

type FormRadioProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> &
  RadioProps;

function FormRadio<TFieldValues extends FieldValues = FieldValues>(
  props: FormRadioProps<TFieldValues>,
) {
  const { name, value: radioValue, ...restProps } = props;
  const {
    field: { value: formValue, ref, ...field },
  } = useController({ ...restProps, name });

  return <Radio checked={radioValue === formValue} {...props} {...field} inputRef={ref} />;
}

export type { FormRadioProps };
export { FormRadio };
